import { Injectable, EventEmitter }    from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http } from '@angular/http';
import { ThirdParty } from '../entity/third-party';
import { User } from '../entity/user';

@Injectable()
export class AuthenticationService {

  private headers = new Headers({'Content-Type': 'application/json'});
  public userChanged$: EventEmitter<User>;

  constructor(private http: Http) {
    this.userChanged$ = new EventEmitter();
  }

  public login(username, password): Promise<any> {
    return this.http.post(environment.apiUrl+'site-login', JSON.stringify({login: username, password: password}), {headers: this.headers})
               .toPromise()
               .then(
                  function(response){
                    let user = new User();
                    user.fromJSON(response.json().user);
                    user.thirdParty = response.json().thirdParty;
                    localStorage.setItem('user', JSON.stringify(user));
                    this.userChanged$.emit(user);
                    let success: boolean =  true;
                    let message: string = response.json().message;
                    return { success, message };
                  }.bind(this),
                  function(response){
                    let message: string = response.json().errorMessage;
                    let success: boolean =  false;
                    return { success, message };
                  }
                )
               .catch(this.handleError);
  }

  public forgotten(mail: string): Promise<any> {
    return this.http.post(environment.apiUrl + 'forgotten', JSON.stringify({mail: mail}), {headers: this.headers})
      .toPromise()
      .then(
        function(response){
          const success =  true;
          const message = 'Un mail vous a été envoyé contenant un lien pour réinitialiser votre mot de passe.';
          return { success, message };
        }.bind(this),
        function(response){
          const message: string = response.json().errorMessage;
          const success =  false;
          return { success, message };
        }
      )
      .catch(this.handleError);
  }

  public resetPwd(token: string, pwd: string): Promise<any> {
    return this.http.post(environment.apiUrl + 'reset-pwd', JSON.stringify({token, pwd}), {headers: this.headers})
      .toPromise()
      .then(
        function(response){
          const success =  true;
          const message = 'Votre mot de passe a été réinitialisé.';
          const mail = response.json().mail;
          return { success, message, mail};
        }.bind(this),
        function(response){
          const message: string = response.json().errorMessage;
          const success =  false;
          return { success, message };
        }
      )
      .catch(this.handleError);
  }

  public bypass(bypassThirdParty, bypassKey): Promise<any> {
    return this.http.post(environment.apiUrl + 'site-login', JSON.stringify({bypassThirdParty: bypassThirdParty, bypassKey: bypassKey}), {headers: this.headers})
     .toPromise()
     .then(
        function(response){
          let user = new User();
          user.fromJSON(response.json().user);
          user.thirdParty = response.json().thirdParty;
          localStorage.setItem('user', JSON.stringify(user));
          this.userChanged$.emit(user);
          let success: boolean =  true;
          let message: string = response.json().message;
          return { success, message };
        }.bind(this),
        function(response){
          let message: string = response.json().errorMessage;
          let success: boolean =  false;
          return { success, message };
        }
      )
     .catch(this.handleError);
  }

  public logout(): Promise<boolean> {
    localStorage.removeItem('user');
    this.userChanged$.emit(null);
    return Promise.resolve(true);
  }

  public isAuthenticated(): boolean {
    if (localStorage.getItem("user")) {
      return true;
    } else {
      return false;
    }
  }

  public getCurrentUser(): User {
    let user = new User();
    if (localStorage.getItem("user")) {
      user.fromJSON(JSON.parse(localStorage.getItem("user")));
    }
    return user;
  }

  public editUserInfos(thirdParty: ThirdParty): void {
    let currentUser = this.getCurrentUser();
    currentUser.thirdParty = thirdParty;
    localStorage.setItem('user', JSON.stringify(currentUser));
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/security/authentication.service.ts